import {observer} from 'mobx-react';
import {FormFieldLine} from "../../../../../../../components/form-field-line/form-field-line";
import {Input} from "../../../../../../../components/inputs/input/input";
import {IValidationGroup} from "../../../../../../../hooks/validation-group/validation-group-hook";
import UspsDirectOauthCredentialsStore from "../../../../stores/credentials/shipping/usps-direct-oauth-credentials-store";

interface IProps {
    credentialsStore: UspsDirectOauthCredentialsStore,
    vGroup: IValidationGroup,
}

const UspsDirectOauthCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {

    return (
        <>
            <FormFieldLine
                required
                label='Account Code'
                key='accountCode'
                note='Your USPS "Merchant Account Code" (not account ID)'
            >
                <Input
                    value={credentialsStore.accountId}
                    onChange={credentialsStore.setAccountId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Mailer ID'
                key='mailerId'
                note='The mailer ID from your USPS account, corresponding to the address for returns'
            >
                <Input
                    value={credentialsStore.mailerId}
                    onChange={credentialsStore.setMailerId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default UspsDirectOauthCredentials;
